import React from 'react';
import Icons from 'components/atoms/Icons';
import Image from 'next/image';
import { Faculty } from 'components/types/FacultyTypes';
import Constants from '../../assets/utils/constant';

type FacultyResultProps = {
  keyProp: string;
  faculty: Faculty;
  isDesktop: boolean;
};

const PersonResult = (props: FacultyResultProps) => {
  const { id, Name, Title, Type, Email, Gender, Phone, Photo } = props.faculty;

  return (
    <div className={`person-result`} key={props.keyProp}>
      <div className="profile-image-outer">
        <div className="profile-image-container">
          <div className="profile-image-bg">
            <Image
              src="/images/profile-bg.png"
              alt=""
              layout="fill"
              objectFit="cover"
            />
          </div>
          {Photo.jsonValue && (
            <div className="profile-image" key={id}>
              <Image
                itemProp="image"
                src={
                  Photo?.jsonValue?.value?.src ||
                  (Gender?.value?.toLowerCase() === 'male'
                    ? Constants.fallbackImages.providerMale
                    : Constants.fallbackImages.providerFemale)
                }
                alt={
                  Photo?.jsonValue?.value?.alt ||
                  (Gender?.value.toLowerCase() === 'male'
                    ? 'Male Profile Image'
                    : 'Female Profile Image')
                }
                layout="fill"
                objectFit="cover"
              />
            </div>
          )}
        </div>
      </div>
      <div className="provider-info result-details">
        {Name.value && (
          <h2 className="h2-card result-name" itemProp="name">
            {Name.value}
          </h2>
        )}
        <p itemProp="title" className="title">
          {Title.value}
        </p>
        <p className="role">{Type.jsonValue.fields.Description.value}</p>
        {!props.isDesktop && (
          <div className="contact-info">
            <div className="card-contact-info">
              <div className="contact-row">
                <div className="icon-envelope">
                  <Icons id="envelope" className="icon-envelope" />
                </div>
                <div className="label-email provider-contact-email">
                  <a href={`mailto:${Email.value}`}>
                    <p>{Email.value}</p>
                  </a>
                </div>
              </div>
              <div className="contact-row">
                <div className="icon-phone">
                  <Icons id="rounded-phone" className="icon-rounded-phone" />
                </div>
                <div className="label-phone provider-contact-phone">
                  <a href={`tel:${Phone.value}`}>
                    <p>
                      {Phone.value &&
                        Phone.value.replace(
                          Phone.value.substring(0, 4),
                          `(${Phone.value.substring(0, 3)}) `
                        )}
                    </p>
                  </a>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {props.isDesktop && (
        <div className="contact-info">
          <div className="card-contact-info">
            {Email.value && (
              <div className="contact-row">
                <div className="icon-envelope">
                  <Icons id="envelope" className="icon-envelope" />
                </div>
                <div className="label-email provider-contact-email">
                  <a href={`mailto:${Email.value}`}>
                    <p>{Email.value}</p>
                  </a>
                </div>
              </div>
            )}
            {Phone.value && (
              <div className="contact-row">
                <div className="icon-phone">
                  <Icons id="rounded-phone" className="icon-rounded-phone" />
                </div>
                <div className="label-phone provider-contact-phone">
                  <a href={`tel:${Phone.value}`}>
                    <p>
                      {Phone.value &&
                        Phone.value.replace(
                          Phone.value.substring(0, 4),
                          `(${Phone.value.substring(0, 3)}) `
                        )}
                    </p>
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default PersonResult;
